import React from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import Breadcrumbs from "./breadcrumbs";
import "./style.scss";
import { useAppContext } from "../../../AppContext";
import Loader from "../../..//components/settings/loader";
import ProtectedRoute from "../../../Wrapper";

const Body = () => {
  const location = useLocation();
  const { user, chimeraserv, components } = useAppContext();

  // Determine base path for matching
  const matchPath = React.useMemo(() => {
    const parts = location.pathname.split("/");

    return parts.length > 2 ? `/${parts[1]}/${parts[2]}` : "/app";
  }, [location.pathname]);

  // Create masked path for breadcrumbs
  const maskedPath = React.useMemo(() => {
    const parts = location.pathname.split("/");

    if (parts.length > 3) {
      // Replace the last part with "View"
      const maskedParts = [...parts.slice(0, -1), "View"];
      return maskedParts.join("/");
    }

    return location.pathname;
  }, [location.pathname]);
  return (
    <section className="body">
      <Breadcrumbs path={maskedPath} />
      {/* <Outlet /> */}

      <Routes>
        <Route index element={React.cloneElement(components.page[0].element)} />

        {components.page.map((route, key) => (
          <Route
            // index={route.path === "dashboard"}
            key={key}
            path={route.path}
            // path={matchPath + route.path}
            element={
              <ProtectedRoute
                element={route.element}
                auth={route.auth}
                fallback={components.setting[0].element}
                route={route}
                user={user}
                chimeraserv={chimeraserv}
                components={components}
              />
            }
          />
        ))}

        <Route
          path="*"
          element={
            components.setting[0].element
              ? React.cloneElement(components.setting[0].element)
              : null
          }
        />
      </Routes>
    </section>
  );
};

export default Body;
